import { svg } from 'lit';

const symbol = svg`<svg width="13" height="17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.254 9.106h6.493m-6.493 1.94h6.493m-6.493 1.939h6.493M4.414 1.227V4.38H1.63M.936 16.5V4.329L4.383.5h7.683v16H.936z" stroke="#F5F5F5"/></svg>`;

export { symbol as default };
